
        import 'AnnualLimitInfo.bc15013.css-module'
        export default {"annualLimitInfo":"annualLimitInfo_AnnualLimitInfo_bc15013","annualLimitInfoModal":"annualLimitInfoModal_AnnualLimitInfo_bc15013"}
    